<div class="mydocma-dialog-container">

  <div class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title">
      {{'MM.syncFaults.dialog.title' | translate}}
    </div>
    <div>
      <button mat-icon-button type= "button" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body" [class.mobile-view]="showMobileView">
    <mydocma-loader class="mydocma-mm-loader" [size]="'small'" *ngIf="loading$ | async"></mydocma-loader>

    <div *ngIf="!showMobileView; else mobileBody" style="height: calc(100% - 20px); width: 100%; margin: 10px; flex: auto">
      <mydocma-grid *ngIf="(gridOptions$ | async)"
        class="ag-theme-alpine mydocma-ag-grid project-config-ag-grid"
        [class.mm-selection-mode]="true"
        [gridOptions]="(gridOptions$ | async)">
        [noRowsOverlayComponent]="noRowsOverlayComponent"-->

      </mydocma-grid>
    </div>
    <ng-template #mobileBody>
      <div class="tile-view">
        <mydocma-mm-faults-sync-status-tile *ngFor="let syncState of currentSyncStates" [syncState]="syncState"></mydocma-mm-faults-sync-status-tile>
      </div>
    </ng-template>

  </div>

  <div class="mydocma-dialog-footer" [class.mobile-view]="showMobileView" style="display: flex; flex-direction: row-reverse;" [style]="((hasErrors$ | async) || !showMobileView) ? 'justify-content: end' : 'justify-content: space-between'">

    <div style="margin-left: 10px" *ngIf="(hasErrors$ | async)">
      <button   #cleanupAndRetrySyncButton mat-stroked-button class="mydocma-btn-primary"
                [matTooltip]="('MM.syncFaults.dialog.cleanupAndRetrySyncTooltip1' | translate) + '\n' + ('MM.syncFaults.dialog.cleanupAndRetrySyncTooltip2' | translate)"
                matTooltipClass="linebreak-tooltip"
                (click)="cleanupAndRetrySync()">
        <!--                [disabled]="(!(userDefinedEditService.hasChanges$ | async) || (userDefinedEditService.saving$ | async)) || !(userDefinedEditService.isFormValid$ | async)">-->
        {{'MM.syncFaults.dialog.cleanupAndRetrySync' | translate}}
      </button>
    </div>
    <div style="margin-left: 10px;" [style]="showMobileView ? ((hasErrors$ | async) ? 'flex: 1;' : 'flex: 0.8;') : ''">
      <button #retrySyncButton  mat-stroked-button [ngClass]="(hasErrors$ | async) ? 'mydocma-btn-secondary' : 'mydocma-btn-primary'"
                [matTooltip]="showMobileView ? 'Upload' : 'MM.syncFaults.dialog.retrySyncTooltip' | translate"
                (click)="retrySync()">
        {{showMobileView ? 'Upload' : 'MM.syncFaults.dialog.retrySync' | translate}}
      </button>
    </div>
    <div *ngIf="!showMobileView; else mobileInfoButton">
      <button #cancelButton mat-stroked-button class="mydocma-btn" (click)="onCancel()"
               [matTooltip]="'MM.syncFaults.dialog.cancelSyncTooltip' | translate">
        {{'MM.general.button.cancel' | translate}}
      </button>
    </div>
    <ng-template #mobileInfoButton>
      <div (click)="openInfoPopup()">
        <mydocma-custom-mat-icon style="font-size: 12px; color: grey" [iconName]="'_info'"></mydocma-custom-mat-icon>
      </div>
    </ng-template>

  </div>

</div>
